import { redirect } from "@tanstack/react-router";
import type { RouterContext } from "@/routes/__root";
import { canAccessRoute, firstAccessibleRoute, type RoutePath } from "./roles";

/**
 * Гард для route-level `beforeLoad`. Якщо у користувача нема доступу до
 * цього маршруту — редіректить його на перший доступний. Якщо жодного
 * маршруту нема (no_access) — залишає на місці, `_auth.tsx` покаже
 * AccessDenied inline.
 *
 * Usage у route:
 *   beforeLoad: ({ context }) => requireRoute(context, "/billing"),
 */
export function requireRoute(context: RouterContext, path: RoutePath): void {
  const role = context.auth.role;
  if (canAccessRoute(role, path)) return;

  const fallback = firstAccessibleRoute(role);
  if (fallback && fallback !== path) {
    throw redirect({ to: fallback });
  }
  // Інакше — нехай _auth.tsx покаже AccessDenied (user без ролі).
}
